module.exports = __webpack_public_path__ + "img/column_202408-2.f6b405ee.jpg";